jQuery(function ($) {
  $('.woocommerce').on(
    'click',
    '[data-action="plus"], [data-action="minus"]',
    function (e) {
      e.preventDefault();
      changeInputQty($(this).data('action'), $(this).siblings('input'));
    }
  );

  var countDecimals = function (value) {
    var splitted = value.toString().split('.');
    if (splitted.length <= 1) {
      return 0;
    }
    return splitted[1].length;
  };

  // read from keyboard presses
  // $("form.cart")
  //   .find("[name=quantity]")
  //   .on("keydown", function (e) {
  //     e.preventDefault();
  //     var action = false;
  //     switch (e.which) {
  //       case 38:
  //         action = "plus";
  //         break;
  //       case 40:
  //         action = "minus";
  //         break;
  //       default:
  //         break;
  //     }
  //     if (action !== false) {
  //       changeInputQty(action, $(this));
  //     }
  //   });

  function changeInputQty(action, input) {
    var step = input.parent().data('step');
    var min = input.parent().data('min');
    var currentValue = parseFloat(input.val());

    // set step by 1 if the min is smaller than 1:
    var newStep = Math.max(1, step);

    if (!isNaN(currentValue)) {
      var newValue =
        action === 'plus' ? currentValue + newStep : currentValue - newStep;
      input.val((newValue < min ? min : newValue).toFixed(countDecimals(step)));
    } else {
      input.val(min);
    }
    input.trigger('input');
  }
});
